module.exports = __webpack_public_path__ + "static/media/saripay-logo-green.a28ff7e0.svg";